export default __webpack_public_path__ + "static/media/bannerThree.4b33f42f.png";